// PATH: src/components/Admin/RequireAdmin.jsx
// VERSION: 1.0 — Protege rutas /admin/*
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';

export default function RequireAdmin({ children }) {
  const { isAdmin } = useAdminAuth();
  const location = useLocation();
  if (!isAdmin) return <Navigate to="/admin" replace state={{ from: location }} />;
  return children;
}
